import React from 'react';
import { Button, Grid } from '@mui/material';
import { useStakingContext } from '../../contexts/staking.context';

export const CheckIn = ({ vault }) => {
  const { checkIn } = useStakingContext();
  return (
    <Grid
      item
      lg={3.2}
      md={4.6}
      sm={12}
      xs={12}
      sx={{
        padding: '8px 20px',
      }}
      display="flex"
      justifyContent={{ xs: 'space-between', md: 'flex-start' }}
      alignItems="center"
    >
      <Grid
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        gap="12px"
        xs={12}
        alignItems="center"
      >
        <Grid display="flex" flexDirection="column">
          <p className="text-white font-poppins text-xs font-normal leading-5">
            Action
          </p>
          <p
            style={{ color: 'rgba(156, 163, 175, 1)', maxWidth: '120px' }}
            className="font-poppins text-xs font-normal leading-5"
          >
            {vault.endsIn} to Check In or lose rewards
          </p>
        </Grid>
        <Button
          sx={{
            height: '39px',
            width: 'auto',
            background:
              'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
            border: '1px solid  #FC9D4B',
            borderColor: '#FC9D4B',
            borderRadius: '25px',
            color: '#FFFFFF',
            fontWeight: 'semibold',
            fontFamily: 'PoppinsRegular',
            fontSize: '14px',
            padding: '7px 15px',
            '&:hover': {
              background:
                'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
              boxShadow: '0px 0px 13px 1px #FC9D4B',
            },
            textTransform: 'none',
            '&.Mui-disabled': {
              background: 'transparent',
              border: '1.5px solid #A3A3B3',
              color: '#A3A3B3',
              boxShadow: 'none',
              cursor: 'not-allowed',
            },
          }}
          disabled={vault.action !== 'Check In'}
          onClick={() => checkIn(vault)}
        >
          Check In
        </Button>
      </Grid>
    </Grid>
  );
};
